<template>
  <v-layout>
    <v-flex>
      <v-runtime-template
        :template="customTemplate"
        :template-props="runtimeContext"
      />
    </v-flex>
  </v-layout>
</template>

<script setup>
import { computed } from 'vue'
import VLayout from 'vuetify/lib/components/VGrid/VLayout'
import VFlex from 'vuetify/lib/components/VGrid/VFlex'
import VRuntimeTemplate from 'v-runtime-template'
import { useTemplate } from '../composables/useTemplate'

const { round, fixed2, fixed3, toHex } = useTemplate()

const props = defineProps({
  packet: {
    type: Object,
    required: false,
    default: null
  },
  customTemplate: {
    type: String,
    required: true,
    validator: value => typeof value === 'string' && value.length > 0
  }
})

// Extrae p y h directamente para que estén disponibles en el template
const runtimeContext = computed(() => ({
  ...props.packet?.parsed?.payload && { p: props.packet.parsed.payload },
  ...props.packet?.parsed?.header && { h: props.packet.parsed.header },
  packet: props.packet,
  round,
  fixed2,
  fixed3,
  toHex
}))
</script>

<style>
/* No style */
</style>